<template>
  <div class="student">
    <van-nav-bar
      title="监护人信息"
      left-text="返回"
      left-arrow
      @click-left="$router.go('-1')"
    />
    <van-cell-group inset style="margin-top:10px">
      <van-field
        v-model="guardian.name"
        name="监护人姓名"
        label="监护人姓名"
        placeholder="监护人姓名"
        :rules="[{ required: true, message: '请填写监护人姓名' }]"
      />
      <van-field
        v-model="guardian.relation"
        is-link
        readonly
        label="监护人关系"
        placeholder="请选择监护人关系"
        @click="showRelation = true"
      />
       <van-popup v-model="showRelation" position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="监护人关系"
          :options="relationList"
          @close="showRelation = false"
          @finish="onRelationFinish"
        />
      </van-popup>
      
      <van-field
        v-model="guardian.addr"
        name="家庭住址"
        label="家庭住址"
        placeholder="家庭住址"
        v-show="showUnit"
        :rules="[{ required: true, message: '请填写家庭住址' }]"
      />
      <van-field
        v-model="guardian.unitname"
        name="单位名称"
        label="单位名称"
        placeholder="单位名称"
        v-show="showUnit"
        :rules="[{ required: true, message: '请填写单位名称' }]"
      />
      <van-field
        v-model="guardian.unitaddr"
        name="单位地址"
        label="单位地址"
        placeholder="单位地址"
        v-show="showUnit"
        :rules="[{ required: true, message: '请填写单位地址' }]"
      />
    </van-cell-group>

    <div style="margin: 16px;">
    <van-button round block type="info" native-type="submit" @click="nextScan">下一步</van-button>
      </div>
  </div>
</template>

<script>
import { NavBar, Cell, CellGroup,Button, Field,Cascader,Toast  } from 'vant'

export default {
  data() {
    return {
      guardian: {
        name:"",
        relation:"",
        addr:"",
        unitname:"",
        unitaddr:""
      },
      showRelation:false,
      showUnit:false,
      cascaderValue:'',
      relationList:[
        {
          text: '爸爸',
          value: '爸爸'
        },
        {
          text: '妈妈',
          value: '妈妈'
        },
        {
          text: '爷爷',
          value: '爷爷'
        },
        {
          text: '奶奶',
          value: '奶奶'
        },
        {
          text: '外公',
          value: '外公'
        },
        {
          text: '外婆',
          value: '外婆'
        },
        {
          text: '叔叔',
          value: '叔叔'
        },
        {
          text: '阿姨',
          value: '阿姨'
        },
        {
          text: '其他',
          value: '其他'
        }
      ],

      
    }
  },
  created() {
   
  },
  mounted() {
    console.log( "districtcode",localStorage.getItem("curDistrictCode"))
    var districtcode = localStorage.getItem("curDistrictCode")
    if (districtcode == "320324") {
      this.showUnit = true
    } else {
      this.showUnit = false
    }
  },
  methods: {
    nextScan:function(){
      var student =JSON.parse(localStorage.getItem("bindStudentinfo"));
      if (student==null){
        Toast.fail("未选择学生")
        return;
      }
      console.log("student",student.studentid);
      // if(this.guardian.name==""){
      //   Toast("请填写监护人姓名");
      //   return;
      // }
      if(this.guardian.relation==""){
        Toast("请选择关系");
        return;
      }
      if (this.showUnit && this.guardian.addr == "") {
        Toast("请填写家庭住址");
        return;
      }
      var gardianinfo ={
          Studentid : eval(student.studentid),
          Relation :this.guardian.relation,
          Guardianname :this.guardian.name,
          Addr:this.guardian.addr,
          Ismaster:eval(student.ismaster),
          Unitname:this.guardian.unitname,
          Unitaddr:this.guardian.unitaddr
      }
      console.log("gardianinfo",JSON.stringify(gardianinfo))
      localStorage.setItem("bindGuardianInfo",JSON.stringify(gardianinfo))
      var bindother = 0
      if (this.$route.query.bindother == 1) { //已有号码直接绑定。
        bindother = 1
        this.$http
                    .json_post(this.$api.baseinfo.bindotherchild, gardianinfo)
                    .then(data => {
                      console.log("data",data);
                      if (data.code===0){
                        Toast.success('绑定成功');
                        //this.$router.push('/devicescan');
                        this.$router.push({ name: 'my' })
                      }else {
                        Toast.fail(data.msg);
                      }
                    })
      } else {
        this.$router.push({name :"familybind",query:{bindother:bindother}});
      }
    },
    onRelationFinish:function(values){
      console.log(values);
      this.guardian.relation=values.selectedOptions[0].text;
      
      this.showRelation =false;
    }
  },
  components: {
    'van-nav-bar': NavBar,
    'van-cell-group': CellGroup,
    'van-cell': Cell,
    'van-field':Field,
    'van-cascader':Cascader ,
    'van-button':Button
  }
}
</script>

<style lang="scss" scoped>
.icon-xuesheng {
  color: $primary-color;
}
</style>
